const reduceWithChild = (cb, accumulator = []) => (list) => list.reduce(
  (resultList, filter) => (filter.children || [filter]).reduce(
    cb,
    resultList
  ),
  accumulator
)

export default reduceWithChild;
